export default __webpack_public_path__ + "static/media/closet1-1920w.6cbd6ae0.webp";